import { component } from 'picoapp';
import app from 'app';
import { clear } from 'utils/node';
import { setProgressWidth, updateProgress } from 'utils/slider';

export default component((node) => {
  const { productId, baseUrl, limit } = node.dataset;

  const init = () => {
    fetch(`${baseUrl}?section_id=template-product-recommendations&product_id=${productId}&limit=${limit}`)
      .then((response) => response.text())
      .then((data) => {
        const container = document.createElement('div');
        container.innerHTML = data;

        clear(node);
        node.insertAdjacentHTML(
          'beforeend',
          container.querySelector('.js-recommendations').innerHTML,
        );
      })
      .then(async () => {
        const { default: KeenSlider } = await import(/* webpackChunkName: "keen-slider" */ 'keen-slider');

        app.mount();

        const container = document.querySelector('.js-recommendations');
        const slider = container.querySelector('[data-slider]');

        const prev = container.querySelector('[data-prev]');
        const next = container.querySelector('[data-next]');

        const progress = container.querySelector('[data-progress]');
        const progressBar = container.querySelector('[data-progress-bar]');

        /* eslint-disable @typescript-eslint/no-unused-expressions */
        function updateClasses(instance) {
          const { relativeSlide, size, slidesPerView: items } = instance.details();

          if (prev) relativeSlide === 0 ? prev.classList.add('is-disabled') : prev.classList.remove('is-disabled');
          if (next) Math.floor(relativeSlide + items) === size ? next.classList.add('is-disabled') : next.classList.remove('is-disabled');
        }
        /* eslint-enable @typescript-eslint/no-unused-expressions */

        /* eslint-disable no-new */
        new KeenSlider(slider, {
          slidesPerView: 1.3,
          spacing: 20,
          duration: 1200,
          breakpoints: {
            '(min-width: 768px)': {
              slidesPerView: 3,
              spacing: 30,
            },
            '(min-width: 1024px)': {
              slidesPerView: 4,
            },
            '(min-width: 1536px)': {
              slidesPerView: 5,
            },
          },
          created(instance) {
            if (prev) prev.addEventListener('click', () => instance.prev());
            if (next) next.addEventListener('click', () => instance.next());

            setProgressWidth(instance, progressBar);
            updateClasses(instance);
          },

          move(instance) {
            updateProgress(instance, progressBar, progress);
          },

          slideChanged(instance) {
            updateClasses(instance);
          },
        });
      });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        init();
        observer.disconnect();
      }
    });
  });

  observer.observe(node);
});
